<h3 class="label">{{ title() }}</h3>
<ng-content></ng-content>
@if (sluitbaar()) {
	<button type="button" class="sluiten" aria-label="Sluiten" (click)="sluiten.emit()">
		<app-icon name="sluiten" color="typography-4"></app-icon>
	</button>
}
